export const coefsByFormat = [
  0.61, // 0s
  0.61,
  0.61,
  0.61,
  0.61,
  0.61, // 5s
  0.61,
  0.61,
  0.61,
  0.61,
  0.61, // 10s
  0.61,
  0.61,
  0.61,
  0.61,
  0.61, // 15s
  0.65,
  0.68,
  0.71,
  0.74,
  0.77, // 20s
  0.81,
  0.84,
  0.86,
  0.89,
  0.91, // 25s
  0.95,
  0.98,
  0.99,
  0.99,
  1, // 30s
  1.04,
  1.07,
  1.1,
  1.14,
  1.17,
  1.2,
  1.23,
  1.26,
  1.3,
  1.33, // 40s
  1.37,
  1.4,
  1.43,
  1.47,
  1.5,
  1.53,
  1.57,
  1.6,
  1.63,
  1.66, // 50s
  1.69,
  1.73,
  1.76,
  1.8,
  1.83,
  1.86,
  1.9,
  1.93,
  1.97,
  2, // 60s
  2.03,
  2.06,
  2.1,
  2.13,
  2.16,
  2.2,
  2.23,
  2.26,
  2.3,
  2.33, // 70s
  2.36,
  2.4,
  2.43,
  2.46,
  2.5,
  2.53,
  2.57,
  2.6,
  2.63,
  2.67, // 80s
  2.7,
  2.73,
  2.77,
  2.8,
  2.83,
  2.87,
  2.9,
  2.93,
  2.97,
  3, // 90s
  3.03,
  3.07,
  3.1,
  3.13,
  3.17,
  3.2,
  3.23,
  3.27,
  3.3,
  3.33, // 100s
  3.37,
  3.4,
  3.43,
  3.47,
  3.5,
  3.53,
  3.57,
  3.6,
  3.63,
  3.67, // 110s
  3.7,
  3.73,
  3.77,
  3.8,
  3.83,
  3.87,
  3.9,
  3.93,
  3.97,
  4, // 120s
  4.03,
  4.07,
  4.1,
  4.13,
  4.17,
  4.2,
  4.23,
  4.27,
  4.3,
  4.33,
  4.37,
  4.4,
  4.43,
  4.47,
  4.5,
  4.53,
  4.57,
  4.6,
  4.63,
  4.67,
  4.7,
  4.73,
  4.77,
  4.8,
  4.83,
  4.87,
  4.9,
  4.93,
  4.97,
  5,
  5.03,
  5.07,
  5.1,
  5.13,
  5.17,
  5.2,
  5.23,
  5.27,
  5.3,
  5.33,
  5.37,
  5.4,
  5.43,
  5.47,
  5.5,
  5.53,
  5.57,
  5.6,
  5.63,
  5.67,
  5.7,
  5.73,
  5.77,
  5.8,
  5.83,
  5.87,
  5.9,
  5.93,
  5.97,
  6,
  6.03,
  6.07,
  6.1,
  6.13,
  6.17,
  6.2,
  6.23,
  6.27,
  6.3,
  6.33,
  6.37,
  6.4,
  6.43,
  6.47,
  6.5,
  6.53,
  6.57,
  6.6,
  6.63,
  6.67,
  6.7,
  6.73,
  6.77,
  6.8,
  6.83,
  6.87,
  6.9,
  6.93,
  6.97,
  7,
  7.03,
  7.07,
  7.1,
  7.13,
  7.17,
  7.2,
  7.23,
  7.27,
  7.3,
  7.33,
  7.37,
  7.4,
  7.43,
  7.47,
  7.5,
  7.53,
  7.57,
  7.6,
  7.63,
  7.67,
  7.7,
  7.73,
  7.77,
  7.8,
  7.83,
  7.87,
  7.9,
  7.93,
  7.97,
  8,
  8.03,
  8.07,
  8.1,
  8.13,
  8.17,
  8.2,
  8.23,
  8.27,
  8.3,
  8.33,
  8.37,
  8.4,
  8.43,
  8.47,
  8.5,
  8.53,
  8.57,
  8.6,
  8.63,
  8.67,
  8.7,
  8.73,
  8.77,
  8.8,
  8.83,
  8.87,
  8.9,
  8.93,
  8.97,
  9,
  9.03,
  9.07,
  9.1,
  9.13,
  9.17,
  9.2,
  9.23,
  9.27,
  9.3,
  9.33,
  9.37,
  9.4,
  9.43,
  9.47,
  9.5,
  9.53,
  9.57,
  9.6,
  9.63,
  9.67,
  9.7,
  9.73,
  9.77,
  9.8,
  9.83,
  9.87,
  9.9,
  9.93,
  9.97,
  10
];
